'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var PeerId = require('peer-id');

var CID = require('cids');

var errCode = require('err-code');

module.exports = function (_ref3) {
  var libp2p = _ref3.libp2p,
      repo = _ref3.repo;
  return {
    /**
     * Given a key, query the DHT for its best value.
     *
     * @param {Buffer} key
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout
     * @returns {Promise<Buffer>}
     */
    get: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // eslint-disable-line require-await
                options = options || {};

                if (Buffer.isBuffer(key)) {
                  _context.next = 9;
                  break;
                }

                _context.prev = 2;
                key = new CID(key).buffer;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](2);
                throw errCode(_context.t0, 'ERR_INVALID_CID');

              case 9:
                return _context.abrupt("return", libp2p._dht.get(key, options));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 6]]);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }(),

    /**
     * Write a key/value pair to the DHT.
     *
     * Given a key of the form /foo/bar and a value of any
     * form, this will write that value to the DHT with
     * that key.
     *
     * @param {Buffer} key
     * @param {Buffer} value
     * @returns {Promise}
     */
    put: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Buffer.isBuffer(key)) {
                  _context2.next = 8;
                  break;
                }

                _context2.prev = 1;
                key = new CID(key).buffer;
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](1);
                throw errCode(_context2.t0, 'ERR_INVALID_CID');

              case 8:
                return _context2.abrupt("return", libp2p._dht.put(key, value));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 5]]);
      }));

      function put(_x6, _x7) {
        return _put.apply(this, arguments);
      }

      return put;
    }(),

    /**
     * Find peers in the DHT that can provide a specific value, given a key.
     *
     * @param {CID} key - They key to find providers for.
     * @param {Object} [options] - findProviders options
     * @param {number} [options.timeout] - how long the query should maximally run, in milliseconds (default: 60000)
     * @param {number} [options.numProviders] - maximum number of providers to find
     * @returns {AsyncIterable<{ id: CID, addrs: Multiaddr[] }>}
     */
    findProvs: function () {
      var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, options) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, peerInfo;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // eslint-disable-line require-await
                options = options || {};

                if (!(typeof key === 'string')) {
                  _context3.next = 9;
                  break;
                }

                _context3.prev = 2;
                key = new CID(key);
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](2);
                throw errCode(_context3.t0, 'ERR_INVALID_CID');

              case 9:
                if (options.numProviders) {
                  options.maxNumProviders = options.numProviders;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context3.prev = 12;
                _iterator = _asyncIterator(libp2p._dht.findProviders(key, options));

              case 14:
                _context3.next = 16;
                return _awaitAsyncGenerator(_iterator.next());

              case 16:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 20;
                return _awaitAsyncGenerator(_step.value);

              case 20:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 28;
                  break;
                }

                peerInfo = _value;
                _context3.next = 25;
                return {
                  id: peerInfo.id.toB58String(),
                  addrs: peerInfo.multiaddrs.toArray()
                };

              case 25:
                _iteratorNormalCompletion = true;
                _context3.next = 14;
                break;

              case 28:
                _context3.next = 34;
                break;

              case 30:
                _context3.prev = 30;
                _context3.t1 = _context3["catch"](12);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 34:
                _context3.prev = 34;
                _context3.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 39;
                return _awaitAsyncGenerator(_iterator.return());

              case 39:
                _context3.prev = 39;

                if (!_didIteratorError) {
                  _context3.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context3.finish(39);

              case 43:
                return _context3.finish(34);

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 6], [12, 30, 34, 44], [35,, 39, 43]]);
      }));

      return function findProvs(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(),

    /**
     * Query the DHT for all multiaddresses associated with a `PeerId`.
     *
     * @param {PeerId} peerId - The id of the peer to search for.
     * @returns {Promise<{ id: CID, addrs: Multiaddr[] }>}
     */
    findPeer: function () {
      var _findPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerId) {
        var peerInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // eslint-disable-line require-await
                if (typeof peerId === 'string') {
                  peerId = PeerId.createFromCID(peerId);
                }

                _context4.next = 3;
                return libp2p._dht.findPeer(peerId);

              case 3:
                peerInfo = _context4.sent;
                return _context4.abrupt("return", {
                  id: peerInfo.id.toB58String(),
                  addrs: peerInfo.multiaddrs.toArray()
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function findPeer(_x8) {
        return _findPeer.apply(this, arguments);
      }

      return findPeer;
    }(),

    /**
     * Announce to the network that we are providing given values.
     *
     * @param {CID|CID[]} keys - The keys that should be announced.
     * @param {Object} [options] - provide options
     * @param {bool} [options.recursive=false] - Provide not only the given object but also all objects linked from it.
     * @returns {Promise}
     */
    provide: function () {
      var _provide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(keys, options) {
        var i, hasKeys, hasAll;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                keys = Array.isArray(keys) ? keys : [keys];
                options = options || {};
                _context5.t0 = _regeneratorRuntime.keys(keys);

              case 3:
                if ((_context5.t1 = _context5.t0()).done) {
                  _context5.next = 15;
                  break;
                }

                i = _context5.t1.value;

                if (!(typeof keys[i] === 'string')) {
                  _context5.next = 13;
                  break;
                }

                _context5.prev = 6;
                keys[i] = new CID(keys[i]);
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t2 = _context5["catch"](6);
                throw errCode(_context5.t2, 'ERR_INVALID_CID');

              case 13:
                _context5.next = 3;
                break;

              case 15:
                _context5.next = 17;
                return Promise.all(keys.map(function (k) {
                  return repo.blocks.has(k);
                }));

              case 17:
                hasKeys = _context5.sent;
                hasAll = hasKeys.every(function (has) {
                  return has;
                });

                if (hasAll) {
                  _context5.next = 21;
                  break;
                }

                throw errCode('block(s) not found locally, cannot provide', 'ERR_BLOCK_NOT_FOUND');

              case 21:
                if (!options.recursive) {
                  _context5.next = 25;
                  break;
                }

                throw errCode('not implemented yet', 'ERR_NOT_IMPLEMENTED_YET');

              case 25:
                _context5.next = 27;
                return Promise.all(keys.map(function (k) {
                  return libp2p._dht.provide(k);
                }));

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[6, 10]]);
      }));

      function provide(_x9, _x10) {
        return _provide.apply(this, arguments);
      }

      return provide;
    }(),

    /**
     * Find the closest peers to a given `PeerId`, by querying the DHT.
     *
     * @param {string|PeerId} peerId - The `PeerId` to run the query against.
     * @returns {AsyncIterable<{ id: CID, addrs: Multiaddr[] }>}
     */
    query: function () {
      var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peerId) {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, closerPeerId;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (typeof peerId === 'string') {
                  peerId = PeerId.createFromCID(peerId);
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context6.prev = 3;
                _iterator2 = _asyncIterator(libp2p._dht.getClosestPeers(peerId.toBytes()));

              case 5:
                _context6.next = 7;
                return _awaitAsyncGenerator(_iterator2.next());

              case 7:
                _step2 = _context6.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context6.next = 11;
                return _awaitAsyncGenerator(_step2.value);

              case 11:
                _value2 = _context6.sent;

                if (_iteratorNormalCompletion2) {
                  _context6.next = 19;
                  break;
                }

                closerPeerId = _value2;
                _context6.next = 16;
                return {
                  id: closerPeerId.toB58String(),
                  addrs: [] // TODO: get addrs?

                };

              case 16:
                _iteratorNormalCompletion2 = true;
                _context6.next = 5;
                break;

              case 19:
                _context6.next = 25;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t0 = _context6["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 25:
                _context6.prev = 25;
                _context6.prev = 26;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context6.next = 30;
                  break;
                }

                _context6.next = 30;
                return _awaitAsyncGenerator(_iterator2.return());

              case 30:
                _context6.prev = 30;

                if (!_didIteratorError2) {
                  _context6.next = 33;
                  break;
                }

                throw _iteratorError2;

              case 33:
                return _context6.finish(30);

              case 34:
                return _context6.finish(25);

              case 35:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[3, 21, 25, 35], [26,, 30, 34]]);
      }));

      return function query(_x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  };
};